/* eslint-disable no-redeclare */
import { z } from 'zod';

export const JourneyAlias = z.enum([
  'HEALTH_DEFAULT',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_GENERIC',
  'MEDICARE_SUPPLEMENT',
  '106', // MP-928
  '107', // MP-1114
  '108', // MP-1119
]);
export type JourneyAlias = z.infer<typeof JourneyAlias>;
